import { render, staticRenderFns } from "./Connect_Wallet.vue?vue&type=template&id=5c1d314e&scoped=true&"
import script from "./Connect_Wallet.vue?vue&type=script&lang=js&"
export * from "./Connect_Wallet.vue?vue&type=script&lang=js&"
import style0 from "./Connect_Wallet.vue?vue&type=style&index=0&id=5c1d314e&scoped=true&lang=css&"
import style1 from "./Connect_Wallet.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1d314e",
  null
  
)

export default component.exports